"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRequest = void 0;
const axios_1 = __importDefault(require("axios"));
const ui_1 = require("@rahtab/ui");
const useMakeAuth_1 = require("./useMakeAuth");
const helpers_1 = require("./helpers");
const react_1 = require("react");
const TokenAuthContext_1 = __importDefault(require("./TokenAuthContext"));
const system_1 = require("@rahtab/system");
const useRequest = ({ url } = {}) => {
    const alert = ui_1.useAlert();
    const { baseURL, setIsSignout } = react_1.useContext(TokenAuthContext_1.default);
    const makeAuth = useMakeAuth_1.useMakeAuth({
        url: baseURL,
        onAuthenticationFailed: () => setIsSignout(true),
    });
    const request = (callType, { useAuthJson = true, numberOfRetry = 4, method = 'GET', params = '', useLastToken = false, timeout = 5000, data, headers, } = {
        useAuthJson: true,
        useLastToken: false,
        numberOfRetry: 4,
        method: 'GET',
        timeout: 5000,
        params: '',
    }) => {
        return new Promise(async (resolve, reject) => {
            if (useAuthJson) {
                var authToken = await makeAuth(useLastToken);
            }
            const requestAddress = helpers_1.urlBuilder({ baseAddress: url || baseURL, callType, params, authJson: authToken });
            axios_1.default({
                url: requestAddress,
                method,
                data,
                headers,
                timeout,
            })
                .then(async (res) => {
                console.log('response', res);
                if (res.data === helpers_1.AUTH_FAILED_ERROR) {
                    const nextNumber = numberOfRetry - 1;
                    console.log('failed', nextNumber, res.data, authToken);
                    if (nextNumber > 0) {
                        request(callType, { useAuthJson, numberOfRetry: nextNumber, params, method, data, headers });
                    }
                    else if (nextNumber === 0) {
                        await helpers_1.removeAuthoriseDataFromStorage();
                        useMakeAuth_1.clearTokens();
                        setIsSignout(true);
                    }
                }
                else if (res.request.responseURL.toLowerCase().includes('failer/excuse.aspx')) {
                    reject({ code: system_1.networkLink.NetworkLinkErrorCode.ServerError });
                }
                else {
                    resolve(res.data);
                }
            })
                .catch((err) => {
                console.log('helperErr', err);
                reject({ code: system_1.networkLink.NetworkLinkErrorCode.NetworkError });
            });
        });
    };
    return request;
};
exports.useRequest = useRequest;
